import React, { useState, useEffect } from 'react';
import { Table, Card, Select, Space, message, Button } from 'antd';
import axios from 'axios';
import { API_URL } from '../config';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';

const { Option } = Select;

// Настройка axios для работы с CORS
const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

const HonestMark = () => {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        xfree: 'Все',
        xdone: 'Все',
        status: 'Все',
        article: location.state?.articleFilter || null
    });

    useEffect(() => {
        if (location.state?.articleFilter) {
            setFilters(prev => ({
                ...prev,
                article: location.state.articleFilter
            }));
        }
    }, [location.state?.articleFilter]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const params = {};
            
            if (filters.xfree !== 'Все') params.xfree = filters.xfree;
            if (filters.xdone !== 'Все') params.xdone = filters.xdone;
            if (filters.status !== 'Все') params.status = filters.status;
            if (filters.article) params.article = filters.article;

            const response = await axiosInstance.get(`${API_URL}/v1/TrueMark/GetAllCZ`, {
                params,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.data && response.data.xdata) {
                setData(response.data.xdata);
            } else {
                message.warning('Данные не получены');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            if (error.response) {
                message.error(`Ошибка: ${error.response.status} - ${error.response.data?.message || 'Неизвестная ошибка'}`);
            } else if (error.request) {
                message.error('Сервер не отвечает. Проверьте подключение.');
            } else {
                message.error('Ошибка при загрузке данных');
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [filters]);

    const handleFilterChange = (value, type) => {
        setFilters(prev => ({
            ...prev,
            [type]: value
        }));
    };

    const handleAction = async (action, keyData) => {
        try {
            const token = localStorage.getItem('token');
            let endpoint = '';
            
            switch(action) {
                case 'free':
                case 'release':
                    endpoint = `${API_URL}/v1/TrueMark/SetOneCZFree`;
                    break;
                case 'occupy':
                    endpoint = `${API_URL}/v1/TrueMark/SetCZOUT`;
                    break;
                default:
                    return;
            }

            const response = await axiosInstance.get(endpoint, {
                params: { id: keyData },
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.data && response.data.statusCode === 200) {
                message.success('Операция выполнена успешно');
                fetchData(); // Обновляем данные после успешного действия
            } else {
                message.error('Ошибка при выполнении операции');
            }
        } catch (error) {
            console.error('Error performing action:', error);
            message.error('Ошибка при выполнении операции');
        }
    };

    // Функция для скачивания списка кодов маркировки
    const handleDownloadCodes = () => {
        // Фильтруем только "В обороте" и "Доставлено"
        const filtered = data.filter(item =>
            !item.Deleted_fromCZ && (item.status === 'доставлено')
        );
        if (filtered.length === 0) {
            message.info('Нет подходящих кодов для скачивания');
            return;
        }
        // Формируем txt: одна строка — один код
        const txt = filtered.map(item => item.KeyData).join('\n');
        const blob = new Blob([txt], { type: 'text/plain;charset=utf-8;' });
        saveAs(blob, 'mark_codes_in_circulation_and_delivered.txt');
    };

    const columns = [
        {
            title: 'Арт',
            dataIndex: 'Article',
            key: 'Article',
            width: 60,
        },
        {
            title: 'SKU',
            dataIndex: 'sku',
            key: 'sku',
            width: 80,
        },
        {
            title: 'Наименование',
            dataIndex: 'name',
            key: 'name',
            width: 100,
            ellipsis: false,
        },
        {
            title: 'Код маркировки',
            dataIndex: 'KeyData',
            key: 'KeyData',
            width: 50,
            ellipsis: false,
        },


        {
            title: 'USE',
            dataIndex: 'Use',
            key: 'USE',
            width: 40,
            render: (text, record) => {
                const status = record.Use ? 'Занят' : 'Свободен';
                const color = record.Use ? 'text-red-600' : 'text-green-600';
                return <span className={color}>{status}</span>;
            }
        },
        {
            title: 'Выведен?',
            dataIndex: 'Deleted_fromCZ',
            key: 'Deleted_fromCZ',
            width: 50,
            render: (text, record) => {
                const status1 = record.Deleted_fromCZ ? 'Выведен' : 'В обороте';
                const color1 = record.Deleted_fromCZ ? 'text-red-600' : 'text-green-600';
                return <span className={color1}>{status1}</span>;
            },
        },

        {
            title: 'Номер отправления',
            dataIndex: 'PostNumberUse',
            key: 'PostNumberUse',
            width: 95,
        },
        {
            title: 'Статус',
            dataIndex: 'status',
            key: 'status',
            width: 90,
            render: (text, record) => {
                const status1 = record.status
                // const status1 = record.status ? 'Выведен' : 'В обороте';
                const color1 = record.status=="отменено" ? 'text-red-600' : 'text-green-600';
                return <span className={color1}>{status1}</span>;
            },
        },
        {
            title: 'Действия',
            key: 'actions',
            width: 300,
            render: (_, record) => (
                <Space size="small">
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => handleAction('free', record.KeyData)}
                        className="bg-blue-500"
                    >
                        Вывести
                    </Button>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => handleAction('occupy', record.KeyData)}
                        className="bg-green-500"
                    >
                        Занять
                    </Button>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => handleAction('release', record.KeyData)}
                        className="bg-yellow-500"
                    >
                        Освободить
                    </Button>
                </Space>
            ),
        }

        // {
        //     title: 'Дата отгрузки',
        //     dataIndex: 'ship_date',
        //     key: 'ship_date',
        //     width: 120,
        // },
        // {
        //     title: 'Дата доставки',
        //     dataIndex: 'deliv_date',
        //     key: 'deliv_date',
        //     width: 120,
        // }
    ];

    return (
        <div className="w-full p-4">
            <Card className="mb-4 w-full">
                <div className="flex justify-between items-center mb-4">
                    <h1 className="text-2xl font-bold">
                        Честный знак
                        {filters.article && (
                            <span className="ml-2 text-gray-500 text-lg">
                                (Артикул: {filters.article})
                            </span>
                        )}
                    </h1>
                    <Space size="large">
                        <div>
                            <span className="mr-2">Статус занятости:</span>
                            <Select
                                value={filters.xfree}
                                onChange={(value) => handleFilterChange(value, 'xfree')}
                                style={{ width: 150 }}
                            >
                                <Option value="Все">Все</Option>
                                <Option value="Занят">Занят</Option>
                                <Option value="Свободен">Свободен</Option>
                            </Select>
                        </div>
                        <div>
                            <span className="mr-2">Статус оборота:</span>
                            <Select
                                value={filters.xdone}
                                onChange={(value) => handleFilterChange(value, 'xdone')}
                                style={{ width: 150 }}
                            >
                                <Option value="Все">Все</Option>
                                <Option value="В обороте">В обороте</Option>
                                <Option value="Выведен">Выведен</Option>
                            </Select>
                        </div>
                        <div>
                            <span className="mr-2">Статус доставки:</span>
                            <Select
                                value={filters.status}
                                onChange={(value) => handleFilterChange(value, 'status')}
                                style={{ width: 150 }}
                            >
                                <Option value="Все">Все</Option>
                                <Option value="Доставлено">Доставлено</Option>
                                <Option value="Доставляется">Доставляется</Option>
                                <Option value="отменено">Отменено</Option>
                            </Select>
                        </div>
                        <Button
                            type="primary"
                            onClick={handleDownloadCodes}
                            style={{ background: '#1890ff', color: 'white' }}
                        >
                            Скачать коды "В обороте" и "Доставлено"
                        </Button>
                        {filters.article && (
                            <button
                                onClick={() => handleFilterChange(null, 'article')}
                                className="px-3 py-1 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                            >
                                Сбросить фильтр по артикулу
                            </button>
                        )}
                    </Space>
                </div>
            </Card>

            <Card className="w-full">
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="_id"
                    loading={loading}
                    scroll={{ x: true, y: 'calc(100vh - 300px)' }}
                    pagination={{
                        pageSize: 50,
                        showSizeChanger: true,
                        showTotal: (total) => `Всего ${total} записей`
                    }}
                />
            </Card>
        </div>
    );
};

export default HonestMark; 